import { Link } from "react-router-dom";
import { ArrowUpRight, FileText, FlaskConical } from "lucide-react";
import GradeBadge from "./GradeBadge";
import PurityBar from "./PurityBar";

const ProductCard = ({ product, featured = false }) => {
  const ctaLabel = product.ctaLabel || "Reserve Allocation";
  const intent = product.ctaIntent || "reserve";

  return (
    <article
      data-testid={`product-card-${product.id}`}
      className={`hover-card-product bg-white p-7 md:p-9 flex flex-col h-full ${featured ? "md:col-span-2" : ""}`}
    >
      <div className="flex items-start justify-between gap-4">
        <GradeBadge grade={product.grade} />
        <span className="font-mono text-[10px] uppercase tracking-widest text-brand-black/45 text-right">{product.tier}</span>
      </div>

      <h3 className="font-display text-3xl md:text-4xl mt-5 text-brand-black tracking-tight">{product.name}</h3>
      <p className="text-sm text-brand-black/65 mt-3 leading-relaxed max-w-prose">{product.summary}</p>

      <div className="mt-6">
        <PurityBar value={product.purityLevel} label={product.purityRatio || "Purity ratio (A620/A280)"} />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4 mt-7 pt-6 border-t border-brand-green/10">
        <div>
          <p className="eyebrow text-brand-green/70">Forms</p>
          <p className="text-sm mt-1.5 text-brand-black/80">{product.forms.join(" · ")}</p>
        </div>
        <div>
          <p className="eyebrow text-brand-green/70">Documentation</p>
          <p className="text-xs mt-1.5 text-brand-black/75 leading-relaxed">{product.documentation || "Technical review pathway"}</p>
        </div>
      </div>

      <div className="mt-6">
        <p className="eyebrow text-brand-green/70 mb-3">Applications</p>
        <div className="flex flex-wrap gap-2">
          {product.applications.map((a) => (
            <span key={a} className="text-[11px] tracking-wide px-2.5 py-1 bg-brand-cream border border-brand-green/15 text-brand-black/75">
              {a}
            </span>
          ))}
        </div>
      </div>

      <div className="mt-5">
        <p className="eyebrow text-brand-green/70 mb-2">Certifications & Pathway</p>
        <p className="text-xs font-mono text-brand-teal tracking-wide leading-relaxed">{product.certifications.join("  ·  ")}</p>
      </div>

      <div className="mt-auto pt-8 flex flex-wrap items-center gap-3">
        <Link
          to={`/reserve-allocation?product=${product.id}&intent=${intent}`}
          data-testid={`product-cta-${product.id}`}
          className="btn-primary text-xs uppercase tracking-[0.18em] !py-3 !px-5 min-h-[44px]"
        >
          {ctaLabel} <ArrowUpRight size={14} />
        </Link>
        <button
          data-testid={`product-cta-tds-${product.id}`}
          onClick={() => window.alert(`Technical dossier for ${product.name} — available on request via the reserve-allocation form, or email export@spiruva.com.`)}
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-brand-black/70 hover:text-brand-gold transition border-b border-brand-black/20 hover:border-brand-gold py-1 min-h-[44px]"
        >
          <FileText size={13} /> Technical Dossier
        </button>
        <span className="ml-auto inline-flex items-center gap-1.5 text-[11px] font-mono uppercase tracking-widest text-brand-black/40">
          <FlaskConical size={12} /> Pre-Launch Review
        </span>
      </div>
    </article>
  );
};

export default ProductCard;
